/* eslint-disable security/detect-object-injection */

import { PanCardRegex } from "../../CommonMethods/PanCardRegex";

export const UpdateDocumentValidation =(error, setError, state)=>{
    let flag = false;
    
    Object.keys(error).forEach(async(item) => {
        switch (item) {
        case "pan_file_url":
            if(state[item] === "") {
                setError((prevState) => ({ ...prevState, [item]: true }));
                flag = true
            }
            break;
        case "pan_number":
        case "registration_number":
            if(state[item] === "") {
                setError((prevState) => ({ ...prevState, [item]: true }));
                flag = true
            }
            break;
        case "pan_validate":
            const val = await PanCardRegex(state.pan_number)
            if(state.pan_validate !== ""  && !val) {
                setError((prevState) => ({ ...prevState, [item]: true }));
                flag = true
            }
            break;            
        default:
            break;
        }
    })
    return flag
      
}